export class NewChallan {
    idChallanItem:number;
    challanItemNameDes:string;
    challanItemQrCode:string;
   challanItemQty:number;
   idChallan:number;
    operationState="i";
    IsRemove :false;

}